export default "__VITE_ASSET__hk0eWL8cxGBeGXVsYM8rQw__"